export default {"src":"/_next/static/media/returns.4c5440c8.svg","height":24,"width":24};